import { Body1, Caption1, makeStyles, Text, tokens } from '@fluentui/react-components';

import { spacing } from '@/theme/tokens';
import type { AiUsageModel } from '@/api/types';

interface ModelsCardProps {
  models: readonly AiUsageModel[];
  pricingSource: string;
}

const useStyles = makeStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.s,
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gap: spacing.s,
    alignItems: 'baseline',
  },
  sku: {
    fontWeight: 600,
  },
  details: {
    color: tokens.colorNeutralForeground3,
    fontFeatureSettings: '"tnum" 1',
  },
  source: {
    color: tokens.colorNeutralForeground3,
    marginTop: spacing.m,
  },
  empty: {
    color: tokens.colorNeutralForeground3,
  },
});

const integer = (v: number): string => v.toLocaleString();
const usd = (v: number): string =>
  v.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 2 });

export function ModelsCard({ models, pricingSource }: ModelsCardProps) {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.list}>
        {models.length === 0 ? (
          <Body1 className={classes.empty}>No model usage in this window.</Body1>
        ) : (
          models.map((m) => (
            <div key={`${m.endpoint}|${m.deployment}|${m.sku}`} className={classes.row}>
              <div>
                <Text className={classes.sku}>{m.sku}</Text>{' '}
                <Text className={classes.details}>
                  · {m.deployment} @ {m.endpoint}
                </Text>
              </div>
              <Text className={classes.details}>
                in {integer(m.tokensIn)} · out {integer(m.tokensOut)} · {usd(m.costUsd)}
              </Text>
            </div>
          ))
        )}
      </div>
      <Caption1 className={classes.source} block>
        Pricing source: {pricingSource}
      </Caption1>
    </div>
  );
}
